module.exports = __webpack_public_path__ + "img/send-letter.a8f12a90.png";